import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Button, CircularProgress, Slide } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import TruckIcon from '@material-ui/icons/LocalShipping';
import RefreshIcon from '@material-ui/icons/Refresh';
import MapIcon from '@material-ui/icons/Room';

import AuthUserContainer from '../../../containers/AuthUser';
import ChevronRightIcon from '../../../images/icons/chevronRightLarge.svg';
import { post } from '../../../modules/utility';
import { getGlobalMobileClasses } from '../../../themes';
import MobileHeader from '../common/MobileHeader';

import MobileDeliveryErrorDialog from './dialogs/MobileDeliveryErrorDialog';
import MobileDeliveryCommodities from './MobileDeliveryCommodities';
import MobileDeliveryLoadStop from './MobileDeliveryLoadStop';
import MobileDeliveryNotes from './MobileDeliveryNotes';
import {
	convertEventTypeToDisplay,
	generalStyles,
	getOverrideParams,
	LEG_OUT_STATUS,
	MobileDeliveryCommodityProduct,
	STOP_STATUS,
	stopStatusToDisplay,
	stopStatusToStyle,
} from './util';

const testUserId = sessionStorage.getItem('testMobile-testUserId') || '';

const brightOrange = '#FF3D00';
const linkColor = brightOrange;

const styles = (theme) => {
	return {
		...getGlobalMobileClasses(theme),
		masterContainer: {
			position: 'relative',
			height: '100%',
			backgroundColor: 'white',
			fontSize: '120%',
		},
		contentTitle: {
			display: 'flex',
			alignItems: 'center',
			borderBottom: '1px solid #ddd',
			paddingBottom: 15,
			marginBottom: 15,
		},
		ticketRow: {
			display: 'flex',
			borderBottom: '1px solid #ccc',
			width: '100%',
		},
		ticketRowContent: {
			display: 'flex',
			boxSizing: 'border-box',
			width: '100%',
			padding: '3vw',
			justifyContent: 'space-between',
			alignItems: 'center',
			lineHeight: 1.3,
		},
		tickerLabel: {
			fontSize: '80%',
			textTransform: 'uppercase',
			color: '#222',
			fontWeight: 900,
		},
		ticketChevronButton: {
			//backgroundColor: stlBlue,
			borderRadius: '.5vw',
			color: 'white',
			fontWeight: 'bold',
			lineHeight: 1,
			marginRight: '2vw',
			minWidth: 'auto',
			padding: `3vw 3vw`,
		},
		ticketChevronRightIcon: {
			display: 'inline-block',
			width: '2.64vw',
			height: '6vw',
			backgroundImage: `url('${ChevronRightIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
		},

		// tops
		loadContainer: {
			padding: '.5vw',
			width: '100%',
			boxSizing: 'border-box',
		},
		stopRow: {
			alignItems: 'center',
			borderBottom: '1px solid #ccc',
			boxSizing: 'border-box',
			display: 'flex',
			justifyContent: 'space-between',
			lineHeight: 1.3,
			width: '100%',
		},
		stopRowIgnored: {
			alignItems: 'center',
			borderBottom: '1px solid #ccc',
			boxSizing: 'border-box',
			color: '#888',
			display: 'flex',
			fontSize: '80%',
			justifyContent: 'space-between',
			lineHeight: 1,
			width: '100%',
		},
		stopIcon: {
			opacity: 0.6,
			color: '#3478a2',
			marginRight: '1vw',
			textAlign: 'center',
			minWidth: '9vw',
			marginTop: '.5vw',
			//color: stlBlue,
		},
		stopType: {
			fontSize: '70%',
			fontWeight: 1000,
			textTransform: 'uppercase',
		},

		stopTitle: {
			marginTop: '3vw',
			textTransform: 'uppercase',
			color: '#999',
			fontWeight: 200,
			letterSpacing: 2,
			borderBottom: '1px solid #ccc',
		},
		ctaButton: {
			fontWeight: 'bold',
			fontSize: '100%',
			//backgroundColor: stlBlue,
			color: 'white',
			padding: `2vw 3vw`,
			lineHeight: 1,
			borderRadius: 4,
			marginRight: '.5vw',
			marginTop: '.5vw',
			marginBottom: '.5vw',
		},

		stopButton: {
			fontWeight: 'bold',
			fontSize: '100%',
			//backgroundColor: stlBlue,
			color: 'white',
			padding: `3.33vw 5.8vw`,
			lineHeight: 1,
			borderRadius: 4,
			marginRight: '1.6vw',
			marginTop: '1.6vw',
			marginBottom: '1.6vw',
			minWidth: '40vw',
		},

		refreshButton: {
			borderRadius: 4,
			margin: '1vw',
			fontSize: '70%',
			fontWeight: 'bold',
			padding: `1vw 1.5vw`,
			lineHeight: 1,
			maxHeight: 'auto',
			minWidth: 'auto',
		},

		notesContainer: {
			fontSize: '90%',
			marginTop: 5,
		},
		notesSection: {
			marginBottom: 3,
		},

		//
		// Slide  in screens
		//
		slideInBackground: {
			width: '100%',
			height: '100%',
			position: 'absolute',
			zIndex: 2,
		},
		slideInFixedBackground: {
			backgroundColor: 'white',
			zIndex: 19,
			position: 'fixed',
			top: '12vw',
			bottom: '20vw',
			left: 0,
			right: 0,
			overflow: 'scroll',
			paddingLeft: '3vw',
			paddingRight: '3vw',
			paddingTop: '3vw',
		},
		slideInAbsBackground: {
			width: '100%',
			height: '100%',
			backgroundColor: 'white',
			position: 'absolute',
			zIndex: 20,
		},

		truckIcon: {
			opacity: 1,
			color: '#555',
			textAlign: 'center',
			padding: '1vw',
			paddingTop: '2vw',
			paddingRight: 0,
			paddingLeft: '2vw',
			//color: stlBlue,
		},
		truckIconTripText: {
			marginTop: '-1vw',
			fontWeight: 1000,
			textTransform: 'uppercase',
			whiteSpace: 'nowrap',
			fontSize: '70%',
		},
		emptyNotes: {
			fontStyle: 'italic',
			color: '#999',
		},

		gridTable: {
			margin: 0,
			padding: 0,
			borderCollapse: 'collapse',
			width: '100%',
			lineHeight: 1.4,
			borderSpacing: 0,
			marginTop: '.5vw',
		},
		tankRowHeader: {
			fontSize: '80%',
			textTransform: 'uppercase',
			color: '#222',
			fontWeight: 900,
		},

		linkedOrders: {
			borderLeft: `4px solid ${linkColor}`,
			position: 'absolute',
			left: '45%',
			bottom: '-10%',
			height: '17vw',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			'&::before': {
				position: 'absolute',
				top: 0,
				left: '-1.25vw',
				height: '2vw',
				width: '2vw',
				background: linkColor,
				content: '""',
				borderRadius: '1vw',
			},
			'&::after': {
				boxShadow: '0 2px 2px -1px rgba(0, 0, 0, 0.4)',
				position: 'absolute',
				top: 'auto',
				bottom: 0,
				left: '-1.25vw',
				height: '2vw',
				width: '2vw',
				background: linkColor,
				content: '""',
				borderRadius: '1vw',
			},
		},
		linkedOrdersText: {
			color: linkColor,
			fontSize: '70%',
			marginLeft: '-100%',
			//marginTop: '6.4vw',
			fontWeight: '1000',
			backgroundColor: 'white',
		},

		productAttributes: {
			fontSize: '85%',
			marginTop: 2,
		},
		productAttribute: {
			marginRight: 5,
		},
		...generalStyles,

		// stops
		disabledReason: {
			fontSize: '65%',
			marginBottom: '-1vw',
			marginTop: '1vw',
			color: '#888',
		},
		arrivalDepartureTime: {
			fontSize: '90%',
			marginTop: '-1vw',
			color: '#333',
		},
	};
};

// CHECK AVL
// Change HST

// in STATUS, OUT STATUS

const LEG_OUT_STATUS_DISPLAY = {
	[LEG_OUT_STATUS.PLN]: 'Planned',
	[LEG_OUT_STATUS.UNP]: 'Unplanned',
	[LEG_OUT_STATUS.STD]: 'Started',
	[LEG_OUT_STATUS.DSP]: 'Dispatched',
	[LEG_OUT_STATUS.CMP]: 'Complete',
};

const STATUS_BLUE = '#1289d4';
const STATUS_GREEN = '#43A047';
const LEG_OUT_STATUS_STYLE = {
	[LEG_OUT_STATUS.PLN]: {
		borderLeft: `1px solid ${STATUS_BLUE}`,
		borderRight: `1px solid ${STATUS_BLUE}`,
		color: STATUS_BLUE,
	},
	[LEG_OUT_STATUS.UNP]: {
		borderLeft: `1px solid ${STATUS_BLUE}`,
		borderRight: `1px solid ${STATUS_BLUE}`,
		color: STATUS_BLUE,
	},
	[LEG_OUT_STATUS.STD]: {
		border: `1px solid ${STATUS_BLUE}`,
		backgroundColor: STATUS_BLUE,
		color: 'white',
	},
	[LEG_OUT_STATUS.CMP]: {
		border: `1px solid ${STATUS_GREEN}`,
		backgroundColor: STATUS_GREEN,
		color: 'white',
	},
};

const LEG_OUT_STATUS_BADGE_STYLE = {
	[LEG_OUT_STATUS.PLN]: {
		border: `1px solid ${STATUS_BLUE}`,
		color: STATUS_BLUE,
	},
	[LEG_OUT_STATUS.UNP]: {
		border: `1px solid ${STATUS_BLUE}`,
		color: STATUS_BLUE,
	},
	[LEG_OUT_STATUS.STD]: {
		border: `1px solid ${STATUS_BLUE}`,
		backgroundColor: STATUS_BLUE,
		color: 'white',
	},
	[LEG_OUT_STATUS.CMP]: {
		border: `1px solid ${STATUS_GREEN}`,
		backgroundColor: STATUS_GREEN,
		color: 'white',
	},
};

/*const LEG_BORDER = { borderTop: 0, borderBottom: 0 };
const LEG_OUT_STATUS_STYLE = {
	[LEG_OUT_STATUS.PLN]: { color: 'blue', border: '1px solid blue', ...LEG_BORDER },
	[LEG_OUT_STATUS.UNP]: { color: 'blue', border: '1px solid blue', ...LEG_BORDER },
	[LEG_OUT_STATUS.STD]: { color: 'blue', border: '1px solid blue', ...LEG_BORDER },
	[LEG_OUT_STATUS.CMP]: { color: '#43A047', border: '1px solid #43A047', ...LEG_BORDER },
};
*/

function legOutStatusToStyle(legOutStatus) {
	return LEG_OUT_STATUS_STYLE[legOutStatus] || { border: '1px solid gray', color: 'gray' };
}

function legOutStatusToBadgeStyle(legOutStatus) {
	return LEG_OUT_STATUS_BADGE_STYLE[legOutStatus] || { border: '1px solid gray', color: 'gray' };
}

function legOutStatusToDisplay(legOutStatus) {
	return LEG_OUT_STATUS_DISPLAY[legOutStatus] || 'Unknown';
}

class MobileDeliveries extends Component {
	constructor(props) {
		super(props);
		const id = parseInt(_.get(this.props, 'match.params.id'), 10) || undefined;
		const stopNumber = parseInt(_.get(this.props, 'match.params.stopNumber'), 10) || undefined;

		this.state = {
			order: 'desc',
			orderBy: 'clockInDateTime',
			lastPunchInfoResults: undefined,
			showClockInSuccessful: false,
			showClockOutSuccessful: false,
			recentTimeClockShifts: undefined,
			selectedId: id,
			selectedStopNumber: stopNumber,
			isShowErrorDialogOpen: false,
			errorDialogMessages: [],
		};
	}

	componentDidMount() {
		this.getDeliveryTickets();
	}

	setFetching = ({ isFetching, isShowErrorDialogOpen, errorDialogMessages }) => {
		const newState = {};
		if (!_.isUndefined(isFetching)) {
			newState.isFetching = isFetching;
		}
		if (!_.isUndefined(isShowErrorDialogOpen)) {
			newState.isShowErrorDialogOpen = isShowErrorDialogOpen;
		}

		if (errorDialogMessages) {
			newState.errorDialogMessages = errorDialogMessages;
		}
		this.setState(newState);
	};

	getDeliveryTickets = (p) => {
		const { authUser } = this.props;
		const callback = p?.callback || _.noop;
		this.setState({ isFetching: true });
		const params = getOverrideParams(authUser?.userId);
		params.isForMobile = true;

		post({
			method: 'tmw.searchDeliveryTickets',
			params,
			callback: (err, r) => {
				if (err) {
					this.setState({
						isFetching: false,
						searchError: err,
					});
					return callback({
						success: true,
					});
				}

				// Look forward and back to:
				// - look back a stop: disable arrival until they depart previous stop
				// - look back a trip: disabled arrival second trip needs previous to be done

				let previousTrip;
				let previousStop;
				r.deliveryTickets.forEach((trip) => {
					if (previousTrip) {
						// previous trip isn't done so we can't start this one
						if (previousTrip.legOutStatus !== LEG_OUT_STATUS.CMP) {
							if (!previousTrip.isSplitWithNextDeliveryId) {
								trip.disabledArriveAndDepartReason = 'Previous trip has not been completed yet.';
							}
						}
					}
					previousTrip = trip;

					trip.stops.forEach((stop) => {
						if (
							previousStop &&
							previousStop.stopEvent !== 'BMT' &&
							previousStop.stopEvent !== 'HLT'
						) {
							if (previousStop.stopDepartureStatus !== STOP_STATUS.DNE) {
								if (!stop.isSecondHalfOfSplitPickup) {
									stop.disabledArriveAndDepartReason = 'Previous stop has not been departed.';
								}
							}
						}
						previousStop = stop;
					});
				});

				this.setState({
					isFetching: false,
					deliveryTickets: r.deliveryTickets,
				});
				return callback({
					success: true,
				});
			},
		});
	};

	componentDidUpdate(prevProps, _prevState, _snapshot) {
		const prevId = parseInt(_.get(prevProps, 'match.params.id'), 10) || undefined;
		const prevStopNumber = parseInt(_.get(prevProps, 'match.params.stopNumber'), 10) || undefined;
		const id = parseInt(_.get(this.props, 'match.params.id'), 10) || undefined;
		const stopNumber = parseInt(_.get(this.props, 'match.params.stopNumber'), 10) || undefined;
		if (prevId !== id) {
			this.setState({ selectedId: id });
		}
		if (prevStopNumber !== stopNumber) {
			this.setState({ selectedStopNumber: stopNumber });
		}
	}

	showErrorDialog = () => {
		this.setState({ isShowErrorDialogOpen: true });
	};
	closeErrorDialog = () => {
		this.setState({
			isShowErrorDialogOpen: false,
		});
	};

	render() {
		const { authUser, classes } = this.props;
		const { deliveryTickets } = this.state;

		// Only for drivers
		if (authUser?.role !== 'driver' && !testUserId && authUser?.userId !== 1) {
			return (
				<>
					<MobileHeader showLogo={true} />
					<div className={classes.globalContent}>{this.renderNonDriverDashboard()}</div>
				</>
			);
		}

		const { selectedId, selectedStopNumber } = this.state;

		let headerLabel = '';
		if (!_.isEmpty(deliveryTickets)) {
			if (selectedId) {
				const deliveryTicket = _.find(deliveryTickets, { id: selectedId });
				headerLabel = `Order #${deliveryTicket?.tmwOrderId}`;

				if (selectedStopNumber) {
					const stop = _.find(deliveryTicket?.stops, { stopNumber: selectedStopNumber });
					headerLabel += ` / Stop #${stop?.stopSequence}`;
				}
			}
		}
		return (
			<>
				{!selectedId ? (
					<MobileHeader showLogo={true} />
				) : (
					<MobileHeader label={headerLabel} showBack={true} history={this.props.history} />
				)}
				<div className={classes.globalContent}>{this.renderDriverDashboard()}</div>
			</>
		);
	}

	renderDriverDashboard = () => {
		const { classes, authUser } = this.props;
		const { selectedId, selectedStopNumber } = this.state;

		//const { classes } = this.props;
		const { deliveryTickets, isFetching, searchError } = this.state;

		if (searchError) {
			return (
				<div style={{ textAlign: 'center', height: '100vh' }}>
					<div style={{ padding: 50, marginTop: 100 }}>
						<div>There was an error with your request.</div>
						<div>{searchError}</div>
						<br />
						<div>Please contact dispatch for your delivery tickets.</div>
					</div>
				</div>
			);
		}

		if (!deliveryTickets) {
			return (
				<div
					style={{
						padding: '2vw',
						fontSize: '180%',
						textAlign: 'center',
						color: '#555',
						fontWeight: 200,
						fontStyle: 'italic',
						marginTop: '5vw',
					}}
				>
					<CircularProgress style={{ marginRight: 10, marginBottom: -5 }} />
					<span>Fetching delivery information...</span>
				</div>
			);
		}

		let selectedDeliveryTicket = null;
		let selectedStop = null;
		if (selectedId) {
			selectedDeliveryTicket = _.find(deliveryTickets, { id: selectedId });

			if (!selectedDeliveryTicket) {
				return <div>Error: {selectedId} not in delivery tickets. Refresh?</div>;
			}

			if (selectedStopNumber) {
				selectedStop = _.find(selectedDeliveryTicket.stops, { stopNumber: selectedStopNumber });
				if (!selectedStop) {
					return (
						<div>
							Error: Stop number ${selectedStopNumber} is not in list of stops. Please hit home
							button.
						</div>
					);
				}
			}
		}

		return (
			<div className={classes.masterContainer}>
				{isFetching && (
					<div
						style={{
							position: 'fixed',
							left: 0,
							top: 0,
							right: 0,
							bottom: 0,
							padding: '4vw',
							fontSize: '150%',
							textAlign: 'center',
							color: '#555',
							fontWeight: 200,
							fontStyle: 'italic',
							opacity: 0.92,
							background: 'white',
							zIndex: 99,
							overflow: 'hidden',
						}}
					>
						<div style={{ marginTop: '25%' }}>
							<div fontSize="400%">
								<CircularProgress
									size="10vw"
									style={{ marginRight: 10, marginBottom: -5, fontSize: '400%' }}
								/>
							</div>
							<span>Updating & fetching latest delivery information...</span>
						</div>
					</div>
				)}

				<MobileDeliveryErrorDialog
					open={this.state.isShowErrorDialogOpen}
					onClose={this.closeErrorDialog}
					errorMessages={this.state.errorDialogMessages}
				/>

				<Slide direction="left" in={!!selectedDeliveryTicket} mountOnEnter unmountOnExit>
					<div className={classes.slideInFixedBackground}>
						<MobileDeliveryLoad
							deliveryTicket={selectedDeliveryTicket}
							classes={classes}
							history={this.props.history}
							getDeliveryTickets={this.getDeliveryTickets}
						/>
					</div>
				</Slide>

				<Slide direction="left" in={!!selectedStop} mountOnEnter unmountOnExit>
					<div className={classes.slideInFixedBackground}>
						<MobileDeliveryLoadStop
							deliveryTicket={selectedDeliveryTicket}
							stop={selectedStop}
							classes={classes}
							history={this.props.history}
							getDeliveryTickets={this.getDeliveryTickets}
							setFetching={this.setFetching}
							authUser={authUser}
						/>
					</div>
				</Slide>

				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<div style={{ padding: '2vw 0px' }}>
						Your orders for {moment().format('dddd, MMMM Do, YYYY')}
					</div>

					<div>
						<Button
							className={classes.refreshButton}
							variant="outlined"
							color="primary"
							aria-label="refresh"
							onClick={() => {
								this.props.history.go(0);
							}}
						>
							<RefreshIcon style={{ fontSize: '200%' }} />
						</Button>
					</div>
				</div>

				{deliveryTickets.map((deliveryTicket, i) => {
					const { deliveryEarliestDate, deliveryLatestDate, commodities } = deliveryTicket;
					const startTime = moment(deliveryEarliestDate).format('HH:00');
					const endTime = moment(deliveryLatestDate).format('HH:00');

					const cmdCodes = _.uniq(_.map(commodities, 'cmdCode').sort());
					return (
						<div
							className={classes.ticketRow}
							key={deliveryTicket.id}
							style={{ borderTop: i === 0 ? '1px solid #ccc' : '' }}
						>
							<div
								style={{
									width: '3vw',
									writingMode: 'vertical-rl',
									textOrientation: 'upright',
									fontSize: '60%',
									textTransform: 'uppercase',
									fontWeight: 500,
									textAlign: 'center',
									verticalAlign: 'center',
									display: 'flex',
									alignContent: 'center',
									alignItems: 'center',
									justifyContent: 'center',
									lineHeight: 2,
									letterSpacing: '-.2vw',
									...legOutStatusToStyle(deliveryTicket.legOutStatus),
								}}
							>
								{legOutStatusToDisplay(deliveryTicket.legOutStatus)}
							</div>
							<div className={classes.truckIcon} style={{ position: 'relative' }}>
								<div>
									<TruckIcon style={{ fontSize: '250%' }} />
								</div>
								<div className={classes.truckIconTripText}>Trip #{deliveryTicket.tripNumber}</div>
								{deliveryTicket.isSplitWithNextDeliveryId && (
									<div className={classes.linkedOrders}>
										<div className={classes.linkedOrdersText}>
											{deliveryTicket.isMilkWithNextDeliveryId ? 'MILK' : 'SPLIT'}
										</div>
									</div>
								)}
							</div>

							<div key={`${i}_${deliveryTicket.stopNumber}`} className={classes.ticketRowContent}>
								<div>
									<div>
										<span className={classes.tickerLabel}>Order #:</span>{' '}
										{deliveryTicket.tmwOrderId}
									</div>
									<div>
										<span className={classes.tickerLabel}>Loading At:</span>{' '}
										{deliveryTicket.loadingFacilityId}
									</div>
									<div>
										<span className={classes.tickerLabel}>Delivery At:</span>{' '}
										{deliveryTicket.deliverySiteId}
									</div>
									<div>
										<span className={classes.tickerLabel}>Delivery Time:</span> {startTime} -{' '}
										{endTime}
									</div>
									<div>
										<span className={classes.tickerLabel}>Bill To:</span> {deliveryTicket.billToId}
									</div>

									{cmdCodes.map((cmdCode) => {
										return (
											<span key={cmdCode}>
												<MobileDeliveryCommodityProduct cmdCode={cmdCode} />
											</span>
										);
									})}
								</div>
								<div>
									<Button
										className={classes.ticketChevronButton}
										variant="contained"
										color="primary"
										aria-label="Go"
										onClick={() => {
											this.props.history.push(`/mobile/loads/${deliveryTicket.id}`);
										}}
									>
										<span className={classes.ticketChevronRightIcon} />
									</Button>
								</div>
							</div>
						</div>
					);
				})}
			</div>
		);
	};

	renderNonDriverDashboard = () => {
		const { classes } = this.props;
		return <div className={classes.contentTitle}>Sphere mobile is for drivers only</div>;
	};
}

MobileDeliveries.propTypes = {
	history: PropTypes.object.isRequired,
	authUser: PropTypes.object,
};
export default _.flow([withStyles(styles), AuthUserContainer])(MobileDeliveries);

//
// Just Load
//
class MobileDeliveryLoad extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		const { deliveryTicket, classes } = this.props;
		if (!deliveryTicket) {
			return null;
		}

		const { deliveryEarliestDate, deliveryLatestDate, stops, legOutStatus } = deliveryTicket;
		const startTime = moment(deliveryEarliestDate).format('HH:00');
		const endTime = moment(deliveryLatestDate).format('HH:00');

		return (
			<div className={classes.loadContainer}>
				{/*
				<div>
					<span className={classes.tickerLabel}>Status:</span>{' '}
					<strong style={{ color: 'green' }}>Dispatched</strong>
				</div>
				*/}
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<div>
						<div>
							<span className={classes.tickerLabel}>Loading:</span>{' '}
							{deliveryTicket.loadingFacilityId}
						</div>

						<div>
							<span className={classes.tickerLabel}>Delivery:</span>{' '}
							{deliveryTicket.deliverySiteName}
						</div>

						<div>
							<span className={classes.tickerLabel}>Delivery Time:</span> {startTime} - {endTime}
						</div>

						<div>
							<span className={classes.tickerLabel}>Status:</span>{' '}
							<span
								style={{
									...legOutStatusToBadgeStyle(legOutStatus),
									fontSize: '70%',
									borderRadius: '2vw',
									paddingLeft: '1vw',
									paddingRight: '1vw',
									paddingTop: '.3vw',
									paddingBottom: '.3vw',
									textTransform: 'uppercase',
									fontWeight: 500,
								}}
							>
								{legOutStatusToDisplay(legOutStatus)}
							</span>
						</div>
					</div>

					<div>
						<div>
							<Button
								className={classes.refreshButton}
								variant="outlined"
								color="primary"
								aria-label="refresh"
								onClick={() => {
									this.props.history.go(0);
								}}
							>
								<RefreshIcon style={{ fontSize: '210%' }} />
							</Button>
						</div>
					</div>
				</div>
				<MobileDeliveryNotes
					shipperNotes={deliveryTicket.shipperNotes}
					consigneeNotes={deliveryTicket.consigneeNotes}
					orderRemark={deliveryTicket.orderRemark}
					classes={classes}
					sectionTitle={'Notes & Remarks'}
				/>
				<MobileDeliveryCommodities commodities={deliveryTicket.commodities} classes={classes} />
				<div className={classes.stopsSection}>
					<div className={classes.stopTitle}>Stops</div>
					{stops.map((stop) => {
						let isRowIgnored = false;
						if (stop.stopEvent === 'EMT') {
							return null;
						}

						if (stop.stopEvent === 'RTP') {
							return null;
						}

						if (
							stop.stopEvent === 'BMT' ||
							stop.stopEvent === 'DLT' ||
							stop.stopEvent === 'HLT' ||
							stop.isFirstHalfOfSplitPickup
						) {
							isRowIgnored = true;
						}

						return (
							<div
								key={stop.stopNumber}
								className={isRowIgnored ? classes.stopRowIgnored : classes.stopRow}
								style={{
									opacity: stop.isPartOfOtherSplitLoad
										? 0.4
										: stop.stopIsForAnotherDriver
										? 0.6
										: 1,
									backgroundColor: stop.stopIsForAnotherDriver ? '#f9f9f9' : 'auto',
								}}
							>
								<div>
									{stop.isPartOfOtherSplitLoad && (
										<div>- Stop is on other half of split load -</div>
									)}
									<div style={{ display: 'flex' }}>
										<div
											style={{
												width: '3vw',
												writingMode: 'vertical-rl',
												textOrientation: 'upright',
												fontSize: '60%',
												textTransform: 'uppercase',
												fontWeight: 500,
												textAlign: 'center',
												verticalAlign: 'center',
												display: 'flex',
												alignContent: 'center',
												alignItems: 'center',
												justifyContent: 'center',
												lineHeight: 2,
												letterSpacing: '-.2vw',
												...stopStatusToStyle(stop.stopStatus, stop.stopDepartureStatus),
											}}
										>
											{stopStatusToDisplay(stop.stopStatus, stop.stopDepartureStatus)}
										</div>

										<div
											className={classes.stopIcon}
											style={{ marginLeft: '1vw', paddingTop: '1vw' }}
										>
											{!isRowIgnored && (
												<>
													<div>
														<MapIcon style={{ fontSize: '200%' }} />
													</div>
													<div className={classes.stopType}>
														{convertEventTypeToDisplay(stop.stopType)}
													</div>
												</>
											)}
										</div>
										<div
											style={{
												marginBottom: '1vw',
												paddingTop: '1vw',
											}}
										>
											<div style={{ fontSize: '100%' }}>
												<strong>Stop #{stop.stopSequence}: </strong>
												{stop.consigneeId}
											</div>
											<div style={{ lineHeight: 1.1, marginTop: '.5vw' }}>
												<div>{stop.stopAddress}</div>
												<div>
													{stop.stopCity} {stop.stopState}, {stop.stopZip}
												</div>
											</div>
											<div style={{ lineHeight: 1.2, marginTop: '.5vw', fontSize: '80%' }}>
												{stop.stopIsForAnotherDriver ? (
													<div style={{ fontWeight: 600 }}>This stop is for another driver</div>
												) : (
													!!stop.estimatedDriveTime && (
														<div>Estimated Drive Time: {stop.estimatedDriveTime}</div>
													)
												)}
												{/* <div>Mileage: {stop.legMileage}</div> */}
											</div>
										</div>
									</div>
								</div>
								<div>
									{!isRowIgnored && (
										<Button
											className={classes.ticketChevronButton}
											variant="contained"
											color="primary"
											aria-label="Go"
											disabled={isRowIgnored}
											onClick={() => {
												this.props.history.push(
													`/mobile/loads/${deliveryTicket.id}/${stop.stopNumber}`
												);
											}}
										>
											<span className={classes.ticketChevronRightIcon} />
										</Button>
									)}
								</div>
							</div>
						);
					})}
				</div>
			</div>
		);
	}
}

MobileDeliveryLoad.propTypes = {
	history: PropTypes.object.isRequired,
	getDeliveryTickets: PropTypes.func.isRequired,
	deliveryTicket: PropTypes.object,
};
